import { blockAdapterBase } from 'volto-ministerio-publico-federal/helpers/BlockAdapter/BlockAdapter';
import type { DestaqueItem } from 'volto-ministerio-publico-federal/components/View/CapaView/helpers';

interface NewsBrain {
  Title?: string;
  Description?: string;
  [key: string]: unknown;
}

/**
 * Ao escolher a notícia no campo Conteúdo, herda o título e a linha de apoio.
 *
 * Só preenche campo vazio — mesma política do bloco `teaser` do Volto. Depois
 * que o editor escreveu algo, trocar a notícia não apaga o trabalho manual;
 * para o preenchimento voltar a rodar, basta limpar o campo.
 *
 * A imagem não entra aqui: ela é herdada em tempo de render por
 * `getDestaqueImageProps`, porque congelar as URLs de escala (que carregam o
 * hash do binário) quebraria o card se a redação trocasse a foto da notícia.
 */
export const buildDestaqueFields = (
  news: NewsBrain,
  item: DestaqueItem = {},
): Partial<DestaqueItem> => {
  const patch: Partial<DestaqueItem> = {};
  if (!item.title && news.Title) patch.title = news.Title;
  if (!item.description && news.Description)
    patch.description = news.Description;
  return patch;
};

export const DestaquesBlockDataAdapter = ({
  block,
  data,
  id,
  onChangeBlock,
  value,
}: {
  block: string;
  data: Record<string, unknown>;
  id: string;
  onChangeBlock: (block: string, data: unknown) => void;
  value: unknown;
}) => {
  blockAdapterBase(
    block,
    data,
    id,
    onChangeBlock,
    value,
    'items',
    buildDestaqueFields,
  );
};

export default DestaquesBlockDataAdapter;
